import { render, staticRenderFns } from "./ConfigureMessagesDialog.vue?vue&type=template&id=12845154&scoped=true"
import script from "./ConfigureMessagesDialog.vue?vue&type=script&lang=js"
export * from "./ConfigureMessagesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12845154",
  null
  
)

export default component.exports